import {
  ArrowRight,
  Block,
  HeadingLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { SwappableToken } from "#/shared/types"
import { TokenIcon } from "#/ui/Token"

import SwapModalValue from "./SwapModalValue"

type SwapModalReviewHeaderProps = {
  tokenIn: SwappableToken
  tokenOut: SwappableToken
  amountIn: string
  amountOut: string
}

export default function SwapModalReviewHeader({
  tokenIn,
  tokenOut,
  amountIn,
  amountOut,
}: SwapModalReviewHeaderProps) {
  const [css, theme] = useStyletron()

  return (
    <>
      <Block
        className={css({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: theme.sizing.scale300,
        })}
      >
        <TokenIcon token={tokenIn} size={theme.sizing.scale1600} />
        <ArrowRight color={theme.colors.black} size={theme.sizing.scale600} />
        <TokenIcon token={tokenOut} size={theme.sizing.scale1600} />
      </Block>
      <HeadingLarge
        as="div"
        className={css({
          textAlign: "center",
          margin: theme.sizing.scale700,
        })}
      >
        Swap{" "}
        <SwapModalValue
          amountIn={amountIn}
          amountOut={amountOut}
          tokenIn={tokenIn}
          tokenOut={tokenOut}
        />
      </HeadingLarge>
    </>
  )
}
